import React from "react";

import PageLayout from "../components/PageLayout";

const HomePage = () => (
  <PageLayout backgroundImageName="whole-band" showContactFooter />
);

export default HomePage;
